const Marionette = require('backbone.marionette'),
    ajaxRequest = require('shared/util/ajaxRequest');

module.exports = Marionette.Behavior.extend({
    initialize: function (options) {
        this.pageOptionsModelProp = options.optionsModelProp || 'pageOptions';
        this.viewModelProp = options.viewModelProp || 'viewModel';
    },
    onBeforeRender: function () {
        this.bindViewModelProperties();
        this.initializePageOptions();
    },
    bindViewModelProperties: function () {
        let viewModel = this.view[this.viewModelProp];
        this.options.autoSaveProps.forEach(prop => {
            viewModel.on(`change:${prop}`, () => this.onPageOptionUpdate(prop));
        });
    },
    onPageOptionUpdate: _.throttle(function (prop) {
        let pageOptionsModel = this.view[this.pageOptionsModelProp];
        let viewModel = this.view[this.viewModelProp];
        let url = pageOptionsModel.url();
        let value = viewModel.get(prop);
        ajaxRequest({
            type: 'POST',
            url: url,
            data: JSON.stringify({
                [prop]: value
            }),
        });
    }, 200),
    // Sends all the page options set during view initialization before render to the server for initialization.
    initializePageOptions: function () {
        let viewModel = this.view[this.viewModelProp];
        let pageOptionsModel = this.view[this.pageOptionsModelProp];
        let url = pageOptionsModel.url();
        let initialPageOptions = _.reduce(this.options.autoSaveProps, (memo, prop) => ({ ...memo, [prop]: viewModel.get(prop) }), {});
        ajaxRequest({
            type: 'POST',
            url: url,
            data: JSON.stringify(initialPageOptions),
        });
    }
});